import React from 'react';
import { Button, Card } from 'react-bootstrap';

const BlogCard = (props) => {
    const {image, link} = props.blog;
    return (
        <div className='col-md-4 p-3'>
            <Card>
                <Card.Img style={{height: '200px'}} className='img-fluid' src={image} alt="" />
                <a target="_blank" href={link}>
                    <Button className='form-control' variant='outline-dark'>See Blog</Button>
                </a>
            </Card>
        </div>
    );
};

export default BlogCard;